import { useEffect } from 'react';
import { resolveAssetUrl } from '@/services/request';

export interface PlayingLesson {
  id: string;
  title: string;
  /** 课时视频相对路径（后端下发的 url 字段） */
  url: string;
}

interface LessonPlayerModalProps {
  open: boolean;
  lesson: PlayingLesson | null;
  onClose: () => void;
}

/** 课时视频播放弹窗（已解锁课时点击后弹出） */
export default function LessonPlayerModal({ open, lesson, onClose }: LessonPlayerModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open || !lesson) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 animate-modal-fade bg-foreground-950/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 animate-modal-pop"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={lesson.title}
      >
        <div className="flex items-center justify-between gap-4 mb-3">
          <h3 className="flex items-center gap-2 font-heading text-base md:text-lg font-bold leading-snug text-foreground-900">
            <span className="shrink-0 w-1.5 h-4 rounded-full bg-primary-500"></span>
            <span className="line-clamp-1">{lesson.title}</span>
          </h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <video
          key={lesson.id}
          src={resolveAssetUrl(lesson.url)}
          controls
          autoPlay
          playsInline
          className="w-full aspect-video rounded-md object-contain bg-foreground-950"
        >
          您的浏览器暂不支持视频播放，请更换浏览器后重试。
        </video>
      </div>
    </div>
  );
}
